// extracted by css-extract-rspack-plugin
export default {"description":"SettingsIslandWithTitle_description__jJKlb"};